/**
 * Daggerheart Formula Utilities
 * 
 * Contains the critical Daggerheart rounding rule and utility functions.
 * Used by the structured formula evaluation system.
 */

/**
 * CRITICAL DAGGERHEART RULE: All fractions are rounded UP
 * 
 * Examples:
 * - Agility = 3, half agility = 1.5 → rounds to 2  
 * - Any value 2.1 → rounds to 3
 * - 0.1, 0.2, 0.5, 0.7, 0.9 → all round to 1
 * - 0 stays 0, whole numbers stay unchanged
 * 
 * @param value - The numeric value to round
 * @returns The value rounded up to the nearest whole number
 */
export function roundUpDaggerheart(value: number): number {
  // Handle edge case for exactly 0
  if (value === 0) {
    return 0;
  }
  
  // Use Math.ceil for all positive values to round up
  // Math.ceil handles whole numbers correctly (returns unchanged)
  return Math.ceil(value);
}